import type * as React from 'react';
const SvgIcoHamburguerMenu = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5.498 12h13.005M5.498 16.002h13.005M5.497 7.998h13.005" stroke="currentColor" />
  </svg>
);
export default SvgIcoHamburguerMenu;
